import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { DeliveryTreeNodeTypes } from '../../enums/DeliveryTreeNodeTypes'
import Delivery from '../../models/Delivery'
import { IDeliveryTreeNode } from '../../models/IDeliveryTreeNode'
import { SharedInfo } from '../../models/SharedInfo'
import DeliveriesStore from '../../stores/domain/Deliveries.store'
import SharedDeliveriesStore from '../../stores/domain/SharedDeliveries.store'
import CommonStore from '../../stores/ui/Common.store'
import { EMPTY_STRING } from '../../utils/usefulStrings'
import DeliveryDetailsStore from '../DeliveryDetails/DeliveryDetails.store'
import DeliveryWorkflowCard from '../ExpandableWorkflowCard/components/DeliveryWorkflowCard'

interface IProps {
  node: IDeliveryTreeNode
  LocationContainerNodeType

  measureSizeFn: () => void

  deliveriesStore?: DeliveriesStore
  common?: CommonStore
  deliveryDetailsStore?: DeliveryDetailsStore
  sharedDeliveriesStore?: SharedDeliveriesStore
}

@inject(
  'deliveriesStore',
  'common',
  'deliveryDetailsStore',
  'sharedDeliveriesStore',
)
@observer
export default class DeliveriesTreeNode extends React.Component<IProps> {
  public componentDidMount() {
    if (this.props.measureSizeFn) {
      requestAnimationFrame(() => {
        this.props.measureSizeFn()
      })
    }
  }

  public render() {
    const { node, LocationContainerNodeType } = this.props
    if (node.nodeType === DeliveryTreeNodeTypes.DELIVERY) {
      return this.renderDeliveryNode()
    }
    return <LocationContainerNodeType node={node} shouldHideAmount={true} />
  }

  private renderDeliveryNode() {
    return (
      <div className="delivery-item bb-light-grey full-height full-width">
        <div className="delivery-item-main-col full-width full-height">
          <div className="delivery-item-data-col full-height full-width nowrap">
            <DeliveryWorkflowCard
              delivery={this.delivery || this.convertedSharedDelivery}
              onClick={this.goToDetails}
              measureSizeFn={this.props.measureSizeFn}
              isShared={!!this.convertedSharedDelivery}
              sharedInfo={!!this.convertedSharedDelivery && this.sharedInfo}
            />
          </div>
        </div>
      </div>
    )
  }

  private goToDetails = () => {
    const { deliveryDetailsStore, common } = this.props
    if (this.delivery) {
      deliveryDetailsStore.setViewMode(this.delivery)
      common.displayDeliveryDetailsView(this.delivery.id)
    } else if (this.convertedSharedDelivery) {
      common.displaySharedDeliveryView(this.convertedSharedDelivery.id)
    }
  }

  private get delivery(): Delivery {
    const {
      node: { id },
      deliveriesStore,
    } = this.props
    return deliveriesStore.byId.get(id as string)
  }

  private get convertedSharedDelivery(): Delivery {
    const {
      node: { id },
      sharedDeliveriesStore,
    } = this.props
    const sharedDelivery = sharedDeliveriesStore.getById(id as string)
    return sharedDelivery && Delivery.fromSharedDeliveryDto(sharedDelivery)
  }

  private get sharedInfo(): SharedInfo {
    const {
      node: { id },
      sharedDeliveriesStore,
    } = this.props
    const sharedDelivery = sharedDeliveriesStore.getById(id as string)
    return new SharedInfo(
      sharedDelivery.responsible,
      sharedDelivery.companyName,
      sharedDelivery.projectUrl,
      sharedDelivery.locationsTo,
      sharedDelivery.locationsFrom,
      EMPTY_STRING,
      EMPTY_STRING,
      sharedDelivery.projectFromId,
    )
  }
}
